import classNames from 'classnames';

import useStyles from './styles';

function LoadingResults() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classNames(classes.largeContainer, classes.animation)} />
      <div className={classNames(classes.smallContainer, classes.animation)} />
    </div>
  );
}
export default LoadingResults;
